import {Box, Button as MuiButton, ButtonProps as MuiButtonProps, CircularProgress} from '@mui/material';
import {forwardRef} from 'react';

export type ButtonProps = MuiButtonProps & {
    loading?: boolean;
    loadingHidesChildren?: boolean;
    loadingText?: string;
};

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
    {
        children,
        loading = false,
        loadingHidesChildren = false,
        loadingText = 'Loading...',
        sx,
        color = 'secondary',
        disabled,
        ...props
    },
    ref,
) {
    const shouldShowChildren = !loadingHidesChildren || (!loading && !loadingHidesChildren);

    return (
        <MuiButton ref={ref} {...props} sx={{columnGap: 1, ...sx}} color={color} disabled={disabled || loading}>
            {loading && <CircularProgress style={{height: '1em', width: '1em'}} sx={{color: 'inherit'}} />}
            {shouldShowChildren && (
                <Box component="span" sx={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                    {loading ? loadingText : children}
                </Box>
            )}
        </MuiButton>
    );
});
